import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

// import JS files
import MuiModal from "../../../shares/MuiModal";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";

// import Others files

const AddBrand = (props) => {
  let windowWidth = window.screen.width;

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    reset,
    formState: { errors },
  } = useForm(
    {
      defaultValues: {
        name: "",}
    }
  );

  const [brandName, setBrandName] = useState();

  const AddBrandApi = useFetch({
    method: "post",
    url: "Brand_Service",

    trigger: false,
    data: { name: brandName },
    // caller: props.getFunc,
    argFunc: (res) => {
      if ("name" in res) {
        toast.error("برند با این نام وجود دارد", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        reset();
        props.getFunc.reFetch();
        // toast.success("برند موردنظر با موفقیت ایجاد شد", {
        //   position: toast.POSITION.TOP_CENTER,
        // });
        // props.setOpenModal(false);
      }
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    setBrandName(data.name);
    AddBrandApi.reFetch();
  };

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-4">
              <span className="text-xs md:text-sm text-gray-700">
                نام برند موردنظر خود را وارد کنید.
              </span>
              <div className="mt-4">
                <MuiTextFieldHook
                  autoFocus
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  label="نام"
                  name="name"
                  control={control}
                  register={{
                    required: {
                      value: true,
                      message: "نام برند را وارد کنید",
                    },
                  }}
                />
              </div>
              <div className="flex justify-end mt-4">
                <MuiButton
                  withoutOnClick
                  type="submit"
                  variant="contained"
                  color="success"
                  text="ایجاد"
                  disabled={AddBrandApi.loading}
                />
              </div>
            </div>
          </form>
        </div>
      </MuiModal>
    </>
  );
};

export default AddBrand;
